/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

/**
 * User feedback: success or failure
 */
export const Feedback = {
  Success: "success",
  Failure: "failure",
} as const;
/**
 * User feedback: success or failure
 */
export type Feedback = ClosedEnum<typeof Feedback>;

export type SubmitFeedbackRequestBody = {
  /**
   * User feedback: success or failure
   */
  feedback: Feedback;
  /**
   * The ID of the chat
   */
  id: string;
};

/** @internal */
export const Feedback$outboundSchema: z.ZodMiniEnum<typeof Feedback> = z.enum(
  Feedback,
);

/** @internal */
export type SubmitFeedbackRequestBody$Outbound = {
  feedback: string;
  id: string;
};

/** @internal */
export const SubmitFeedbackRequestBody$outboundSchema: z.ZodMiniType<
  SubmitFeedbackRequestBody$Outbound,
  SubmitFeedbackRequestBody
> = z.object({
  feedback: Feedback$outboundSchema,
  id: z.string(),
});

export function submitFeedbackRequestBodyToJSON(
  submitFeedbackRequestBody: SubmitFeedbackRequestBody,
): string {
  return JSON.stringify(
    SubmitFeedbackRequestBody$outboundSchema.parse(submitFeedbackRequestBody),
  );
}
